// this file is auto-generated by player script in /assets/cardimages2/generate.mjs
export const CardImageList: string[] = [
'a_day_off.png',
'acceptance.png',
'acceptancevalue.png',
'achievement.png',
'adventure-map.png',
'animating.png',
'announcement.png',
'appreciation.png',
'avoider.png',
'balloons.png',
'be_the_hero.png',
'beach.png',
'beauty.png',
'begin_chat.png',
'belonging.png',
'breaking_barriers.png',
'caring.png',
'caring2.png',
'certificate.png',
'certification.png',
'challenge.png',
'chat.png',
'chat_discussion.png',
'checkboxes.png',
'collaborate.png',
'collaborate_virtually.png',
'commitment.png',
'concern.png',
'controller.png',
'conversation.png',
'courage.png',
'creativity.png',
'curiosity.png',
'curiosityvalue.png',
'departing.png',
'different.png',
'diversity.png',
'dominance.png',
'effectonpersonallife.png',
'equality.png',
'excitement.png',
'excitement2.png',
'exploration.png',
'finish.png',
'freedom.png',
'freedomvalue.png',
'goal.png',
'graduate.png',
'group_video.png',
'growth.png',
'h_policies_rules.png',
'h_safe.png',
'h_salary.png',
'h_supervision.png',
'h_work_conditions.png',
'harmony.png',
'having_fun.png',
'health.png',
'honesty.png',
'honor.png',
'humbleness.png',
'hyper_rational.png',
'hyper_vigilant.png',
'in_progress.png',
'independence.png',
'innovation.png',
'intimacy.png',
'joy-.png',
'justice.png',
'key_points.png',
'loating.png',
'login_signup.png',
'love.png',
'm_work.png',
'make_launch.png',
'mastery.png',
'meeting.png',
'modern_life.png',
'modesty.png',
'moving_forward.png',
'music.png',
'new_ideas.png',
'obedience.png',
'on_the_way.png',
'opinion.png',
'order.png',
'order1.png',
'our_solution.png',
'outer_space.png',
'partying.png',
'people.png',
'personal_goals.png',
'personal_information.png',
'pleaser.png',
'politeness.png',
'power.png',
'power1.png',
'powerful.png',
'powervalue.png',
'prestige.png',
'prosperity.png',
'protection.png',
'purpose.png',
'questions.png',
'raltedned.png',
'recognition.png',
'recognition2.png',
'reflect.png',
'relatedness.png',
'reliability.png',
'respect.png',
'restless.png',
'robotics.png',
'safety-.png',
'self-respect.png',
'show_graph.png',
'smiley.png',
'solution.png',
'space.png',
'stability.png',
'status.png',
'status_ship.png',
'status_update.png',
'stickler.png',
'strength.png',
'success.png',
'surveillance.png',
'thinking_process.png',
'thoughts_in_the_park.png',
'to_the_stars.png',
'tolerance.png',
'trustworthiness.png',
'victim.png',
'vr_chat.png',
'wisdom.png',
'working_late.png',
'working_remotely.png',
'youtube_tutorial.png',
]
